module.exports = __webpack_public_path__ + "9502537c2f42012c1929849785dbc422.svg";